import React, { useState, useEffect, useRef } from "react";
import "./AltaPaciente.css";
import { addPaciente} from "../../../services/pacientes";
import { useNavigate, useLocation } from "react-router-dom";
import {validarNombreLongitud, validarNombreEspacios, validarNombreCaracteres,quitarAcentos, normalizarCURP,validarLongitudCURP,
  validarDigitoVerificador,validarCURPContraDatos,validarFechaCURP,calcularEdadDesdeFechaNacimiento,
  calcularEdadDesdeCURP,validarEdadPaciente,validarFechaNacimientoMinima,esCurpExtranjero,entidadNacimientoUsaCurpGenerica,
  paisNacimientoUsaCurpGenerica,
  validarCurpPacienteVsPrestador,prepararPacienteConFechaNacimientoEstimada, validarSigloCURPContraFechaNacimiento,
  prepararPacienteSinFechaNacimientoEstimada,
  aplicarAnioNacimientoEstimadoPaciente,
  pacienteTieneFechaNacimientoEstimadaActiva,validarFechaNacimientoNoFutura, aplicarMesNacimientoEstimadoPaciente,
 prepararPacienteMenorDeUnAnio,
 prepararPacienteNoMenorDeUnAnio, validarMenorDeUnAnio,
 validarMayorOIgualAUnAnio,} from "../../../utils/validaciones/identidad";
import {msgNombreLongitud, msgNombreEspacios, msgNombreCaracteres, msgApellidoPaternoLongitud,msgApellidoPaternoEspacios,
   msgApellidoPaternoCaracteres,msgApellidoMaternoLongitud,msgApellidoMaternoEspacios,msgApellidoMaternoCaracteres,
   msgLongitudCURP,msgDigitoVerificador,msgFechaCURP,msgEdadPaciente,msgSigloCURPFechaNacimiento,msgFechaNacimientoMinima,msgFechaNacimientoRequerida,
   msgApellidoMaternoRequeridoCURP, msgEntidadNacimientoRequeridaCURP,msgPaisNacimientoRequeridoCURP,
   msgCurpPos1,msgCurpPos2,msgCurpPos3,msgCurpPos4,
   msgCurpPos5,msgCurpPos6,msgCurpPos7,msgCurpPos8,msgCurpPos9,msgCurpPos10,
   msgCurpPos11,msgCurpPos12,msgCurpPos13,msgCurpPos14,msgCurpPos15,msgCurpPos16,
   msgCurpPacientePrestador,msgFechaNacimientoNoFutura, msgEdadEstimadaNoMenorDeUnAnio,
 msgEdadEstimadaNoMayorOIgualAUnAnio,
 msgMesNacimientoRequerido,} from "../../../utils/validaciones/mensajes";
import { getCatalogoPais, getCatalogoEntidades, getCatalogoMunicipios, getCatalogoLocalidades, getCatalogoAfiliacion, getMedicoAuth, getPerfilMedico,   } from "../../../services/usuarios";
import { valoresGeoPorPais, valoresGeoPorEntidad, valoresGeoPorMunicipio, esEntidadEspecial, esMunicipioEspecial } from "../../../utils/validaciones/catalogos";
import ConfirmarPalabraInconvenienteCURP from "../../../utils/validaciones/ConfirmarPalabraInconvenienteCURP";
import { obtenerPrellenadoDesdeAgenda } from "../../../utils/asistenciacaptura/prellenadoAltaDesdeAgenda";

const AltaPaciente = () => {
  const navigate = useNavigate(); 
  const location = useLocation();
  // 🔹 Si viene de "Completar alta" en la agenda, trae la persona a dar de alta
  const pacienteCitaId = location.state?.pacienteCitaId || null;
  const [paciente, setPaciente] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    fecha_nacimiento_estimada: false,
    menor_de_un_anio: false,
    anio_nacimiento_estimado: "",
    mes_nacimiento_estimado: "",
    sexo: "",
    telefono: "",
    correo: "",
    curp: "",
    sexoCURP: null,
    nacionalidad: "",
    estado_civil: "",
    paisNacPaciente: null,
    entidadNacimiento: null,
    afiliacion: [],
    seAutodenominaAfromexicano: null,
    seConsideraIndigena: null,
    migrante: null,
    paisProcedencia: null,
    genero: null,
    paisResidencia: null,
    entidadResidencia: null,
    municipio: null,
    localidad: null,
    direccion: {
      calle: "",
      colonia: "",
      ciudad: "",
      estado: "",
      codigo_postal: "",
    },
    motivo_consulta: "",
  });

  const [errors, setErrors] = useState({});
  const [registroExpress, setRegistroExpress] = useState(false);
  const [curpPrestador, setCurpPrestador] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const [confirmarPalabraInconveniente, setConfirmarPalabraInconveniente] = useState(false);
  const [curpPalabraInconvenienteConfirmada, setCurpPalabraInconvenienteConfirmada] = useState(false);
  const curpPalabraInconvenienteConfirmadaRef = useRef(false);

  useEffect(() => {
    const fetchPerfil = async () => {
      const p = await getPerfilMedico();
      setPerfil(p || {});
    };
    fetchPerfil();
  }, []);

  useEffect(() => {
  const cargarMedico = async () => {
  const medico = await getMedicoAuth();
      if (medico && medico.curpPrestador) {
        setCurpPrestador(medico.curpPrestador);
      }

      
    };
    cargarMedico();
  }, []);

  
  // 🔹 Viene de la agenda: prellenar con lo que ya se sabe de la persona
  useEffect(() => {
    if (!pacienteCitaId) return;

    const prellenar = async () => {
      const datos = await obtenerPrellenadoDesdeAgenda(pacienteCitaId);
      if (!datos) {
        alert("Esta persona ya no está pendiente de alta (puede que ya tenga expediente).");
        return;
      }
      setPaciente((prev) => ({ ...prev, ...datos }));
    };

    prellenar();
  }, [pacienteCitaId]);

  // catalogo paises

  const [listaPaises, setListaPaises] = useState([]);
  const [listaEntidades, setListaEntidades] = useState([]);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [listaLocalidades, setListaLocalidades] = useState([]);
  const [listaAfiliacion, setListaAfiliacion] = useState([]);
  const [afiliacionAbierta, setAfiliacionAbierta] = useState(false);
  const [guardandoPaciente, setGuardandoPaciente] = useState(false);

  useEffect(() => {
    const cargarPaises = async () => {
      const paises = await getCatalogoPais();
      const ordenados = paises.sort((a, b) => {
        if (Number(a.CATALOG_KEY) === 142) return -1;
        if (Number(b.CATALOG_KEY) === 142) return 1;
        return a.DESCRIPCION.localeCompare(b.DESCRIPCION);
      });
      setListaPaises(ordenados);
    };

    cargarPaises();
  }, []);

  useEffect(() => {
    const cargarEntidades = async () => {
      const entidades = await getCatalogoEntidades();
      setListaEntidades(entidades);
    };

    cargarEntidades();
  }, []);

 useEffect(() => {
  const cargarAfiliacion = async () => {
    const afiliaciones = await getCatalogoAfiliacion();
    setListaAfiliacion(afiliaciones);
  };

  cargarAfiliacion();
}, []);

 useEffect(() => {
  if (!paciente.paisNacPaciente) {
    setPaciente((prev) => ({
      ...prev,
      entidadNacimiento: null,
      curp: esCurpExtranjero(prev.curp)
        ? ""
        : prev.curp,
    }));
    return;
  }

  if (Number(paciente.paisNacPaciente) === 142) {
    setPaciente((prev) => ({
      ...prev,
      entidadNacimiento: null,
      curp: esCurpExtranjero(prev.curp)
        ? ""
        : prev.curp,
    }));
    return;
  }

  const geo = valoresGeoPorPais(paciente.paisNacPaciente);
   const usaCurpGenerica = paisNacimientoUsaCurpGenerica(
    paciente.paisNacPaciente
  );
 setPaciente((prev) => ({
    ...prev,
    entidadNacimiento: geo.entidad,
    curp: usaCurpGenerica
  ? "XXXX999999XXXXXX99"
  : esCurpExtranjero(prev.curp)
    ? ""
    : prev.curp,
  }));
}, [paciente.paisNacPaciente]);

  useEffect(() => {
  if (paciente.migrante === 1 || paciente.migrante === 3) {
    setPaciente(prev => ({
      ...prev,
      paisProcedencia: 142
    }));
  }

   if (paciente.migrante === 2) {
    setPaciente(prev => ({
      ...prev,
      paisProcedencia: null
    }));
  }

  if (paciente.migrante === 0 || paciente.migrante === null) {
    setPaciente(prev => ({
      ...prev,
      paisProcedencia: null
    }));
  }
}, [paciente.migrante]);

//Fecha de nacimiento estimada

const handleFechaEstimadaChange = (checked) => {
  if (!perfil?.nom024) return;

  setPaciente((prev) =>
    checked
      ? prepararPacienteConFechaNacimientoEstimada(prev)
      : prepararPacienteSinFechaNacimientoEstimada(prev)
  );
};

const handleAnioNacimientoEstimadoChange = (e) => {
  const value = e.target.value;
  if (!value) {
   setPaciente((prev) => prepararPacienteSinFechaNacimientoEstimada(prev));
   return;
 }

  setPaciente((prev) =>
    aplicarAnioNacimientoEstimadoPaciente(prev, value)
  );
};

const handleMenorDeUnAnioChange = (checked) => {
  if (!perfil?.nom024) return;

  setPaciente((prev) =>
    checked
      ? prepararPacienteMenorDeUnAnio(prev)
      : prepararPacienteNoMenorDeUnAnio(prev)
  );
};

const handleMesNacimientoEstimadoChange = (e) => {
  const value = e.target.value;
  setPaciente((prev) =>
    aplicarMesNacimientoEstimadoPaciente(prev, value)
  );
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "curp") {
      curpPalabraInconvenienteConfirmadaRef.current = false;
      setCurpPalabraInconvenienteConfirmada(false);
   // Esto es para fecha de nacimiento estimada 

      if (pacienteTieneFechaNacimientoEstimadaActiva(perfil, paciente)) {
    return;
        }
      if ( entidadNacimientoUsaCurpGenerica(paciente.entidadNacimiento) ||
        paisNacimientoUsaCurpGenerica(paciente.paisNacPaciente)
      ) {
        return;
      }
  const curpNorm = normalizarCURP(value);
  const esGenerica = esCurpExtranjero(curpNorm);
  

 

  setPaciente({
    ...paciente,
    curp: curpNorm,
    sexoCURP: esGenerica ? paciente.sexoCURP : calcularSexoCURP(curpNorm, paciente.sexoCURP)
  });
  return;
}

    setPaciente({ ...paciente, [name]: value });
  };

  const handleNestedChange = (e, key) => {
    const { name, value } = e.target;
    setPaciente({
      ...paciente,
      [key]: { ...paciente[key], [name]: value },
    });
  };

  const handleAfiliacionChange = (catalogKey) => {
  const valor = String(catalogKey);
  const valoresExclusivos = ["0", "1", "99"];

  setPaciente((prev) => {
    const actuales = Array.isArray(prev.afiliacion)
      ? prev.afiliacion.map(String)
      : [];

    // Si selecciona 0, 1 o 99, queda solo ese valor
    if (valoresExclusivos.includes(valor)) {
      return {
        ...prev,
        afiliacion: actuales.includes(valor) ? [] : [valor],
      };
    }

    // Si ya había 0, 1 o 99, se limpian antes de agregar otro valor
    let nuevos = actuales.filter((v) => !valoresExclusivos.includes(v));

    if (nuevos.includes(valor)) {
      nuevos = nuevos.filter((v) => v !== valor);
    } else {
      if (nuevos.length >= 9) {
        alert("Solo puedes seleccionar hasta 9 afiliaciones.");
        return prev;
      }
      nuevos = [...nuevos, valor];
    }

    return {
      ...prev,
      afiliacion: nuevos,
    };
  });
};

const getResumenAfiliacion = () => {

   const afiliacionesSeleccionadas = Array.isArray(paciente.afiliacion)
    ? paciente.afiliacion
    : [];

  return afiliacionesSeleccionadas
    .map((clave) => {
      const item = listaAfiliacion.find(
        (a) => String(a.CATALOG_KEY) === String(clave)
      );
      return item?.["DESCRIPCIÓN CORTA"] || item?.["DESCRIPCIÓN LARGA"] || clave;
    })
    .join(", ");
};

    const validateForm = () => {
    const newErrors = {};

    if (paciente.telefono && !/^\d{10}$/.test(paciente.telefono)) {
      newErrors.telefono = "❌ El teléfono debe tener exactamente 10 dígitos numéricos.";
    }

    if (!validarFechaNacimientoMinima(paciente.fecha_nacimiento)) {
     msgFechaNacimientoMinima();
     return false;
   }
  
  if (!validarFechaNacimientoNoFutura(paciente.fecha_nacimiento)) {
      msgFechaNacimientoNoFutura();
      return false;
    }

    // Candados de coherencia para fecha estimada (NOM-024)
    if (perfil?.nom024 && paciente.fecha_nacimiento_estimada) {
      // Falta mes cuando es menor de 1 año
      if (paciente.menor_de_un_anio && !paciente.mes_nacimiento_estimado) {
        msgMesNacimientoRequerido();
        return false;
      }

      // Coherencia entre flag "menor de 1 año" y la fecha resultante
      if (paciente.fecha_nacimiento) {
        if (paciente.menor_de_un_anio) {
          if (!validarMenorDeUnAnio(paciente.fecha_nacimiento)) {
            msgEdadEstimadaNoMenorDeUnAnio();
            return false;
          }
        } else {
          if (!validarMayorOIgualAUnAnio(paciente.fecha_nacimiento)) {
            msgEdadEstimadaNoMayorOIgualAUnAnio();
            return false;
          }
        }
      }
    }

    const curpNormalizada = normalizarCURP(paciente.curp || "");

    if (curpNormalizada) {

    if (!validarLongitudCURP(curpNormalizada)) {
      msgLongitudCURP();
      newErrors.curp = true;
      return false;
    }

    if (!validarDigitoVerificador(curpNormalizada)) {
      msgDigitoVerificador();
      newErrors.curp = true;
      return false;
    }

    if (!validarCurpPacienteVsPrestador(curpNormalizada, curpPrestador)) {
      msgCurpPacientePrestador();
      newErrors.curp = true;
      return false;
    }

    // Si es genérica, saltar validaciones de posiciones
    if (!esCurpExtranjero(curpNormalizada)) {

      const resultadoCURP = validarCURPContraDatos(
        curpNormalizada,
        paciente.nombre,
        paciente.apellido_paterno,
        paciente.apellido_materno,
        paciente.fecha_nacimiento,
        paciente.sexoCURP,
        paciente.entidadNacimiento,
        listaEntidades,
        paciente.paisNacPaciente
      );

      if (!resultadoCURP.valida) {
        const msgsPorPosicion = {
          1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
          5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
          9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
          13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
        };
       resultadoCURP.errores.forEach(err => {
        if (err.posicion === 0) {
          if (err.motivo === "fecha_requerida") msgFechaNacimientoRequerida();
          if (err.motivo === "apellido_materno_requerido") msgApellidoMaternoRequeridoCURP();
          if (err.motivo === "pais_nacimiento_requerido") msgPaisNacimientoRequeridoCURP();
          if (err.motivo === "entidad_nacimiento_requerida") msgEntidadNacimientoRequeridaCURP();
          return;
        }

        const msgFn = msgsPorPosicion[err.posicion];
        if (msgFn) msgFn();
      });
        newErrors.curp = true;
        return false;
      }

      if (!validarFechaCURP(curpNormalizada)) {
        msgFechaCURP();
        newErrors.curp = true;
        return false;
      }

      if (!validarSigloCURPContraFechaNacimiento(curpNormalizada, paciente.fecha_nacimiento)) {
        msgSigloCURPFechaNacimiento();
        newErrors.curp = true;
        return false;
      }


      const edad = calcularEdadDesdeCURP(curpNormalizada);

     if (!validarEdadPaciente(edad)) {
        msgEdadPaciente();
      }
    
       if (
        resultadoCURP.requiereConfirmacionPalabraInconveniente &&
        !curpPalabraInconvenienteConfirmadaRef.current
      ) {
        setConfirmarPalabraInconveniente(true);
        newErrors.curp = true;
        return false;
      }

    } // fin de !esCurpExtranjero
    } // fin de if (curpNormalizada)

    if (paciente.direccion.codigo_postal && !/^\d{5}$/.test(paciente.direccion.codigo_postal)) {
      newErrors.codigo_postal = "❌ El Código Postal debe tener 5 dígitos numéricos.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isRegistroCompleto = () => {
    const camposRequeridos = [
        paciente.fecha_nacimiento?.trim(),
        paciente.sexo?.trim(),
        paciente.telefono?.trim(),
        paciente.curp?.trim(),
        paciente.direccion.calle?.trim(),
        paciente.direccion.colonia?.trim(),
        paciente.direccion.ciudad?.trim(),
        paciente.direccion.estado?.trim(),
        paciente.direccion.codigo_postal?.trim()
    ];

    const registroMinimo = paciente.nombre?.trim() && paciente.apellido_paterno?.trim();
    const todosLosCamposLlenos = registroMinimo && camposRequeridos.every(Boolean);

  

    return todosLosCamposLlenos;  
};

  const calcularSexoCURP = (curp, sexoCURPManual = null) => {
  const curpNormalizada = normalizarCURP(curp || "");

  // Si no hay CURP, es genérica o está incompleta, NO se calcula.
  // Se conserva lo que el usuario haya elegido manualmente.
  if (
    !curpNormalizada ||
    curpNormalizada.length !== 18 ||
    esCurpExtranjero(curpNormalizada)
  ) {
    return sexoCURPManual ?? null;
  }

  const caracterSexo = curpNormalizada.charAt(10);

  if (caracterSexo === "H") return 1;
  if (caracterSexo === "M") return 2;
  if (caracterSexo === "X") return 3;

  return sexoCURPManual ?? null;
};
  const handleSubmit = (e) => {
    e.preventDefault();
     // Candado anti-doble-click: si ya se esta guardando, ignora el segundo click.
    if (guardandoPaciente) return;

    const pacienteData = {
      nombre: paciente.nombre,
      apellido_paterno: paciente.apellido_paterno,
      apellido_materno: paciente.apellido_materno || null,
      fecha_nacimiento: paciente.fecha_nacimiento || null,
      fecha_nacimiento_estimada: !!(perfil?.nom024 && paciente.fecha_nacimiento_estimada),
      menor_de_un_anio: !!(perfil?.nom024 && paciente.fecha_nacimiento_estimada && paciente.menor_de_un_anio),
      mes_nacimiento_estimado: paciente.mes_nacimiento_estimado || "",
      sexo: paciente.sexo || null,
      telefono: paciente.telefono || null,
      correo: paciente.correo || null,
      curp: paciente.curp || null,
      nacionalidad: paciente.nacionalidad || null,
      paisNacPaciente: paciente.paisNacPaciente || null,
      entidadNacimiento: paciente.entidadNacimiento || null,
      sexoCURP: calcularSexoCURP(paciente.curp, paciente.sexoCURP),
      seAutodenominaAfromexicano: paciente.seAutodenominaAfromexicano ?? null,
      seConsideraIndigena: paciente.seConsideraIndigena ?? null,
      migrante: paciente.migrante ?? null,
      paisProcedencia: paciente.paisProcedencia ?? null,
      genero: paciente.genero ?? null,
      derechohabiencia: paciente.afiliacion?.length ? paciente.afiliacion.join("&") : null,
      paisResidencia: paciente.paisResidencia || null,
      entidadResidencia: paciente.entidadResidencia || null,
      municipio: paciente.municipio || null,
      localidad: paciente.localidad || null,
      estado_civil: paciente.estado_civil || null,
      motivo_consulta: paciente.motivo_consulta || null,
      direccion: {
        calle: paciente.direccion?.calle || null,
        colonia: paciente.direccion?.colonia || null,
        ciudad: paciente.direccion?.ciudad || null,
        estado: paciente.direccion?.estado || null,
        codigo_postal: paciente.direccion?.codigo_postal || null,
      },
      activo: true,
      ...(pacienteCitaId ? { paciente_cita_id: pacienteCitaId } : {}),
    };

   const sexoMap = { "Hombre": "M", "Mujer": "F", "Intersexual": "O" };
    pacienteData.sexo = sexoMap[paciente.sexo] || null;

    const estado_civilMap = {
      "Soltero": "Soltero/a", "Casado": "Casado/a",
      "Divorciado": "Divorciado/a", "Viudo": "Viudo/a",
      "Unión Libre": "Unión Libre", "Otro": "Otro"
    };
    pacienteData.estado_civil = estado_civilMap[paciente.estado_civil] || null;

 

    if (!validateForm()) {
    
      return;
    }

    if (!isRegistroCompleto()) {
      setRegistroExpress(true);
      return;
    }

    setGuardandoPaciente(true);
    addPaciente(pacienteData)
      .then((response) => {
        if (response) {
          alert("\u2705 Registro exitoso.");
          window.opener?.postMessage({ type: "refreshPacientes" }, "*");
          navigate(pacienteCitaId ? "/dashboard/citas" : "/dashboard/historias-clinicas");
        } else {
          alert("❌ Error al registrar el paciente. Inténtalo de nuevo.");
        }
      })
      .catch((error) => {
        console.error("❌ Error en el servidor:", error);
        alert("❌ Error en el servidor. Inténtalo más tarde.");
       })
      .finally(() => {
        setGuardandoPaciente(false);
      });
  };

  const handleRegistroExpress = (confirm) => {
    if (!confirm) {
      setRegistroExpress(false);
      return;
    }

    // Candado anti-doble-click.
    if (guardandoPaciente) return;
  
    const sexoMap = { "Hombre": "M", "Mujer": "F", "Intersexual": "O" };
    const estado_civilMap = {
      "Soltero": "Soltero/a", "Casado": "Casado/a",
      "Divorciado": "Divorciado/a", "Viudo": "Viudo/a",
      "Unión Libre": "Unión Libre", "Otro": "Otro"
    };
  
    const pacienteExpress = {
      nombre: paciente.nombre,
      apellido_paterno: paciente.apellido_paterno,
      apellido_materno: paciente.apellido_materno || null,
      fecha_nacimiento: paciente.fecha_nacimiento || null,
      fecha_nacimiento_estimada: !!(perfil?.nom024 && paciente.fecha_nacimiento_estimada),
      menor_de_un_anio: !!(perfil?.nom024 && paciente.fecha_nacimiento_estimada && paciente.menor_de_un_anio),
      mes_nacimiento_estimado: paciente.mes_nacimiento_estimado || "",
      sexo: sexoMap[paciente.sexo] || null,
      telefono: paciente.telefono || null,
      correo: paciente.correo || null,
      curp: paciente.curp || null,
      nacionalidad: paciente.nacionalidad || null,
      paisNacPaciente: paciente.paisNacPaciente || null,
      entidadNacimiento: paciente.entidadNacimiento || null,
      sexoCURP: calcularSexoCURP(paciente.curp, paciente.sexoCURP),
      seAutodenominaAfromexicano: paciente.seAutodenominaAfromexicano ?? null,
      seConsideraIndigena: paciente.seConsideraIndigena ?? null,
      migrante: paciente.migrante ?? null,
      paisProcedencia: paciente.paisProcedencia ?? null,
      genero: paciente.genero ?? null,
      derechohabiencia: paciente.afiliacion?.length ? paciente.afiliacion.join("&") : null,
      paisResidencia: paciente.paisResidencia || null,
      entidadResidencia: paciente.entidadResidencia || null,
      municipio: paciente.municipio || null,
      localidad: paciente.localidad || null,
      estado_civil: estado_civilMap[paciente.estado_civil] || null,
      motivo_consulta: paciente.motivo_consulta || null,
      direccion: {
        calle: paciente.direccion?.calle || null,
        colonia: paciente.direccion?.colonia || null,
        ciudad: paciente.direccion?.ciudad || null,
        estado: paciente.direccion?.estado || null,
        codigo_postal: paciente.direccion?.codigo_postal || null,
      },
      activo: true,...(pacienteCitaId ? { paciente_cita_id: pacienteCitaId } : {}), 

    };

   
    
    setGuardandoPaciente(true);
    addPaciente(pacienteExpress)
      .then((response) => {
        if (response) {
          alert("\u2705 Registro express exitoso. Puedes completar los datos más tarde.");
          window.opener?.postMessage({ type: "refreshPacientes" }, "*");
          navigate(pacienteCitaId ? "/dashboard/citas" : "/dashboard/historias-clinicas");
        } else {
          alert("❌ Error en el registro express. Inténtalo de nuevo.");
        }
      })
      .catch((error) => {
        console.error("❌ Error en el servidor:", error);
        alert("❌ Error en el servidor. Inténtalo más tarde.");
        })
      .finally(() => {
        setGuardandoPaciente(false);
      });
  };

  // Cascada residencia
  const handlePaisResidencia = (valor) => {
    const geo = valoresGeoPorPais(valor);
    setPaciente((prev) => ({
      ...prev,
      paisResidencia: valor,
      entidadResidencia: geo.entidad,
      municipio: geo.municipio,
      localidad: geo.localidad,
    }));
    setListaMunicipios([]);
    setListaLocalidades([]);
  };

  const handleEntidadResidencia = async (valor) => {
    const geo = valoresGeoPorEntidad(valor);
    setPaciente((prev) => ({
      ...prev,
      entidadResidencia: valor || null,
      municipio: geo.municipio,
      localidad: geo.localidad,
    }));
    setListaLocalidades([]);
    if (valor && !esEntidadEspecial(valor)) {
      const municipios = await getCatalogoMunicipios(valor);
      setListaMunicipios(municipios.sort((a, b) => (a.MUNICIPIO || "").trim().localeCompare((b.MUNICIPIO || "").trim(), 'es')));
    } else {
      setListaMunicipios([]);
    }
  };

  const handleMunicipio = async (valor) => {
    const geo = valoresGeoPorMunicipio(valor);
    setPaciente((prev) => ({
      ...prev,
      municipio: valor || null,
      localidad: geo.localidad,
    }));
    setListaLocalidades([]);
    if (valor && !esMunicipioEspecial(valor) && paciente.entidadResidencia) {
      const localidades = await getCatalogoLocalidades(paciente.entidadResidencia, valor);
      setListaLocalidades(localidades.sort((a, b) => (a.LOCALIDAD || "").trim().localeCompare((b.LOCALIDAD || "").trim(), 'es')));
    }
  };


  const handleBlurCURPPaciente = () => {
    const curp = normalizarCURP(paciente.curp || "");
    if (!curp) return;

    if (!validarLongitudCURP(curp)) {
      msgLongitudCURP();
      return;
    }

    if (!validarDigitoVerificador(curp)) {
      msgDigitoVerificador();
      return;
    }

    if (!validarCurpPacienteVsPrestador(curp, curpPrestador)) {
      msgCurpPacientePrestador();
      return;
    }

    if (esCurpExtranjero(curp)) return;

    if (!validarFechaCURP(curp)) {
      msgFechaCURP();
      return;
    }
    
    if (!validarSigloCURPContraFechaNacimiento(curp, paciente.fecha_nacimiento)) {
      msgSigloCURPFechaNacimiento();
      return;
    }

    const edad = calcularEdadDesdeCURP(curp);
    if (!validarEdadPaciente(edad)) {
      msgEdadPaciente();
      return;
    }

     const resultadoCURP = validarCURPContraDatos(
      curp,
      paciente.nombre,
      paciente.apellido_paterno,
      paciente.apellido_materno,
      paciente.fecha_nacimiento,
      paciente.sexoCURP,
      paciente.entidadNacimiento,
      listaEntidades,
       paciente.paisNacPaciente
    );

    if (!resultadoCURP.valida) {
      const msgsPorPosicion = {
        1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
        5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
        9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
        13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
      };
      resultadoCURP.errores.forEach(err => {
        const msgFn = msgsPorPosicion[err.posicion];
        if (msgFn) msgFn();
      });
    }
  };

   

   return (
    <div className="alta-paciente-form">
      <h2>Registro de Paciente</h2>
        <p className="info-express">
    ⚡ Puedes completar solo <strong>Nombre</strong> y <strong>Apellido Paterno</strong> para un registro express. Más tarde podrás agregar el resto de la información.
    Los campos marcados con * son obligatorios. Una vez iniciada la primera consulta, ya no se podrán mover estos datos.
        </p>
         {pacienteCitaId && (
        <p className="info-express">
          📅 Estás completando el alta de una persona agendada. Revisa los datos prellenados y completa lo que falte.
        </p>
      )}

      <form onSubmit={handleSubmit}>
      <div>
        {/* Datos Generales */}
        <h3>Datos Generales</h3>
        <input
          type="text"
          name="nombre"
          placeholder="Nombre*"
          value={paciente.nombre}
          onChange={handleChange}
          required
          onBlur={(e) => {
            const v = quitarAcentos(e.target.value.trim());
            setPaciente(prev => ({ ...prev, nombre: v }));
            if (!validarNombreLongitud(v)) {
              msgNombreLongitud();
              setPaciente(prev => ({ ...prev, nombre: "" }));
            } else if (!validarNombreEspacios(v)) {
              msgNombreEspacios();
              setPaciente(prev => ({ ...prev, nombre: "" }));
            } else if (!validarNombreCaracteres(v)) {
              msgNombreCaracteres();
              setPaciente(prev => ({ ...prev, nombre: "" }));
            }
          }}
        />
        <input
          type="text"
          name="apellido_paterno"
          placeholder="Apellido Paterno*"
          value={paciente.apellido_paterno}
          onChange={handleChange}
          required
          onBlur={(e) => {
            const v = quitarAcentos(e.target.value.trim());
            setPaciente(prev => ({ ...prev, apellido_paterno: v }));
            if (!validarNombreLongitud(v)) {
              msgApellidoPaternoLongitud();
              setPaciente(prev => ({ ...prev, apellido_paterno: "" }));
            } else if (!validarNombreEspacios(v)) {
              msgApellidoPaternoEspacios();
              setPaciente(prev => ({ ...prev, apellido_paterno: "" }));
            } else if (!validarNombreCaracteres(v)) {
              msgApellidoPaternoCaracteres();
              setPaciente(prev => ({ ...prev, apellido_paterno: "" }));
            }
          }}
        />
        <input
          type="text"
          name="apellido_materno"
          placeholder="Apellido Materno*"
          value={paciente.apellido_materno}
          onChange={handleChange}
          onBlur={(e) => {
            const v = quitarAcentos(e.target.value.trim());
            setPaciente(prev => ({ ...prev, apellido_materno: v }));
            if (!validarNombreLongitud(v)) {
              msgApellidoMaternoLongitud();
              setPaciente(prev => ({ ...prev, apellido_materno: "" }));
            } else if (!validarNombreEspacios(v)) {
              msgApellidoMaternoEspacios();
              setPaciente(prev => ({ ...prev, apellido_materno: "" }));
            } else if (!validarNombreCaracteres(v)) {
              msgApellidoMaternoCaracteres();
              setPaciente(prev => ({ ...prev, apellido_materno: "" }));
            }
          }}
        />
        {perfil?.nom024 && paciente.fecha_nacimiento_estimada ? (
          <>
            {/* Input de mes — solo cuando es menor de 1 año */}
            {paciente.menor_de_un_anio && (
              <select
                name="mes_nacimiento_estimado"
                value={paciente.mes_nacimiento_estimado || ""}
                onChange={handleMesNacimientoEstimadoChange}
                onBlur={() => {
                 if (!paciente.anio_nacimiento_estimado || !paciente.mes_nacimiento_estimado) return;
                 if (!paciente.fecha_nacimiento) return;

                 if (!validarFechaNacimientoNoFutura(paciente.fecha_nacimiento)) {
                   msgFechaNacimientoNoFutura();
                   setPaciente(prev => ({
                     ...prev,
                     fecha_nacimiento: "",
                     mes_nacimiento_estimado: "",
                   }));
                   return;
                 }

                 if (paciente.menor_de_un_anio) {
                   if (!validarMenorDeUnAnio(paciente.fecha_nacimiento)) {
                     msgEdadEstimadaNoMenorDeUnAnio();
                     setPaciente(prev => ({
                       ...prev,
                       fecha_nacimiento: "",
                       mes_nacimiento_estimado: "",
                     }));
                     return;
                   }
                 }
               }}
              
              >
                <option value="">Mes aproximado de nacimiento*</option>
                <option value="01">Enero</option>
                <option value="02">Febrero</option>
                <option value="03">Marzo</option>
                <option value="04">Abril</option>
                <option value="05">Mayo</option>
                <option value="06">Junio</option>
                <option value="07">Julio</option>
                <option value="08">Agosto</option>
                <option value="09">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
            )}

            <input
              type="text"
              name="anio_nacimiento_estimado"
              placeholder="Año aproximado de nacimiento*"
              value={paciente.anio_nacimiento_estimado}
              maxLength={4}
              onChange={handleAnioNacimientoEstimadoChange}
             onBlur={() => {
                // Si está marcado menor de 1 año pero falta mes, avisar y salir.
                if (paciente.menor_de_un_anio && !paciente.mes_nacimiento_estimado) {
                  msgMesNacimientoRequerido();
                  return;
                }

                if (!paciente.fecha_nacimiento) return;

                if (!validarFechaNacimientoMinima(paciente.fecha_nacimiento)) {
                  msgFechaNacimientoMinima();
                  setPaciente(prev => ({
                    ...prev,
                    fecha_nacimiento: "",
                    anio_nacimiento_estimado: "",
                    mes_nacimiento_estimado: "",
                  }));
                  return;
                }

                if (!validarFechaNacimientoNoFutura(paciente.fecha_nacimiento)) {
                  msgFechaNacimientoNoFutura();
                  setPaciente(prev => ({
                    ...prev,
                    fecha_nacimiento: "",
                    anio_nacimiento_estimado: "",
                    mes_nacimiento_estimado: "",
                  }));
                  return;
                }

                const edad = calcularEdadDesdeFechaNacimiento(paciente.fecha_nacimiento);
                if (!validarEdadPaciente(edad)) {
                  msgEdadPaciente();
                  setPaciente(prev => ({
                    ...prev,
                    fecha_nacimiento: "",
                    anio_nacimiento_estimado: "",
                    mes_nacimiento_estimado: "",
                  }));
                  return;
                }

                // Candado de coherencia entre el flag "menor de 1 año" y la fecha resultante.
                if (paciente.menor_de_un_anio) {
                  if (!validarMenorDeUnAnio(paciente.fecha_nacimiento)) {
                    msgEdadEstimadaNoMenorDeUnAnio();
                    setPaciente(prev => ({
                      ...prev,
                      fecha_nacimiento: "",
                      anio_nacimiento_estimado: "",
                      mes_nacimiento_estimado: "",
                    }));
                    return;
                  }
                } else {
                  if (!validarMayorOIgualAUnAnio(paciente.fecha_nacimiento)) {
                    msgEdadEstimadaNoMayorOIgualAUnAnio();
                    setPaciente(prev => ({
                      ...prev,
                      fecha_nacimiento: "",
                      anio_nacimiento_estimado: "",
                    }));
                    return;
                  }
                }
              }}
            />

            <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "-6px" }}>
              {paciente.menor_de_un_anio
                ? `Se registrará como 15/${paciente.mes_nacimiento_estimado || "[mes]"}/${paciente.anio_nacimiento_estimado || "[año]"} conforme a la guía.`
                : `Se registrará como 30/06/${paciente.anio_nacimiento_estimado || "[año]"} conforme a la guía.`}
            </p>
          </>
        ) : (
          <input
            type="text"
            name="fecha_nacimiento"
            placeholder="Fecha de Nacimiento*"
            value={paciente.fecha_nacimiento}
            onChange={handleChange}
            onFocus={(e) => (e.target.type = "date")}
            onBlur={(e) => {
              e.target.type = "text";
              if (!validarFechaNacimientoMinima(paciente.fecha_nacimiento)) {
                msgFechaNacimientoMinima();
                setPaciente(prev => ({ ...prev, fecha_nacimiento: "" }));
              }
              if (!validarFechaNacimientoNoFutura(paciente.fecha_nacimiento)) {
                msgFechaNacimientoNoFutura();
                setPaciente(prev => ({ ...prev, fecha_nacimiento: "" }));
                return;
              }
            }}
          />
        )}

        {perfil?.nom024 && (
          <label className="fecha-estimada-check">
            <input
              type="checkbox"
              checked={!!paciente.fecha_nacimiento_estimada}
              onChange={(e) => handleFechaEstimadaChange(e.target.checked)}
            />
            <span>Se desconoce fecha de nacimiento</span>
          </label>
        )}

        {perfil?.nom024 && paciente.fecha_nacimiento_estimada && (
          <label className="fecha-estimada-check">
            <input
              type="checkbox"
              checked={!!paciente.menor_de_un_anio}
              onChange={(e) => handleMenorDeUnAnioChange(e.target.checked)}
            />
            <span>Es menor de 1 año</span>
          </label>
        )}
        <select
          name="sexo"
          value={paciente.sexo}
          onChange={handleChange}
        >
          <option value="">Selecciona sexo biológico*</option>
          <option value="Hombre">Hombre</option>
          <option value="Mujer">Mujer</option>
          <option value="Intersexual">Intersexual</option>
        </select>
        <input
          type="text"
          name="telefono"
          placeholder="Teléfono"
          value={paciente.telefono}
          onChange={handleChange}
        />
        {errors.telefono && <p className="error">{errors.telefono}</p>}

        <input
          type="email"
          name="correo"
          placeholder="Correo Electrónico"
          value={paciente.correo}
          onChange={handleChange}
        />
        <select
          name="paisNacPaciente"
          value={paciente.paisNacPaciente ?? ""}
          onChange={(e) =>
            setPaciente({
              ...paciente,
              paisNacPaciente: e.target.value ? Number(e.target.value) : null
            })
          }
        >
          <option value="">País de nacimiento*</option>
          {listaPaises.map((pais) => (
            <option
              key={pais.CATALOG_KEY}
              value={pais.CATALOG_KEY}
              
            >
              {pais.DESCRIPCION}
            </option>
          ))}
        </select>
        
        {/*<input
          type="text"
          name="nacionalidad"
          placeholder="Nacionalidad"
          value={paciente.nacionalidad}
          onChange={handleChange}
        />*/}
        
     {Number(paciente.paisNacPaciente) === 142 && (
          <select
            name="entidadNacimiento"
            value={paciente.entidadNacimiento ?? ""}
           onChange={(e) => {
              const entidad = e.target.value || null;
              const usaCurpGenerica = entidadNacimientoUsaCurpGenerica(entidad);

              setPaciente({
                ...paciente,
                entidadNacimiento: entidad,
                curp: usaCurpGenerica
                  ? "XXXX999999XXXXXX99"
                  : esCurpExtranjero(paciente.curp)
                    ? ""
                    : paciente.curp,
              });
            }}
          >
           <option value="">Seleccione entidad de nacimiento*</option>

           {listaEntidades
            .filter((entidad) => String(entidad.CATALOG_KEY) !== "88")
            .map((entidad) => (
              <option key={entidad.CATALOG_KEY} value={entidad.CATALOG_KEY}>
                {entidad.ENTIDAD_FEDERATIVA}
              </option>
            ))}
          </select>
        )}

        <input
          type="text"
          name="curp"
          placeholder="CURP*"
          maxLength={18}
          value={paciente.curp}
          onChange={handleChange}
          onBlur={handleBlurCURPPaciente}
          disabled={
            pacienteTieneFechaNacimientoEstimadaActiva(perfil, paciente) ||
            entidadNacimientoUsaCurpGenerica(paciente.entidadNacimiento) ||
            paisNacimientoUsaCurpGenerica(paciente.paisNacPaciente)
          }
        />
        {errors.curp && <p className="error">{errors.curp}</p>}
        {perfil?.nom024 && (
          <select
            name="sexoCURP"
            value={paciente.sexoCURP ?? ""}
            disabled={
              !!normalizarCURP(paciente.curp || "") &&
              !esCurpExtranjero(normalizarCURP(paciente.curp || ""))
            }
            onChange={(e) =>
              setPaciente({
                ...paciente,
                sexoCURP: e.target.value === "" ? null : Number(e.target.value)
              })
            }
          >
            <option value="">Sexo registrado ante RENAPO*:</option>
            <option value="1">HOMBRE</option>
            <option value="2">MUJER</option>
            <option value="3">NO BINARIO</option>
          </select>
        )}
        <select
          name="estado_civil"
          value={paciente.estado_civil}
          onChange={handleChange}
        >
          <option value="">Seleccionar Estado Civil</option>
          <option value="Soltero">Soltero</option>
          <option value="Casado">Casado</option>
          <option value="Divorciado/a">Divorciado/a</option>
          <option value="Viudo/a">Viudo/a</option>
          <option value="Unión Libre">Unión Libre</option>
          <option value="Otro">Otro</option>
        </select>

        {/* Información sociodemográfica NOM-024 */}
         {perfil?.nom024 && (
        <>
        <h3>Información sociodemográfica</h3>
          <div className="campo-afiliacion">
            <button
              type="button"
              className={`afiliacion-toggle ${afiliacionAbierta ? "abierto" : ""}`}
              onClick={() => setAfiliacionAbierta((prev) => !prev)}
            >
              <div>
                <span className="afiliacion-label">Derechohabiencia*</span>
                <span className={`afiliacion-resumen ${paciente.afiliacion?.length ? "con-seleccion" : ""}`}>
                  {getResumenAfiliacion()}
                </span>
              </div>
              <span className="afiliacion-flecha">
                {afiliacionAbierta ? "▲" : "▼"}
              </span>
            </button>

            {afiliacionAbierta && (
              <div className="afiliacion-panel">
                <p className="afiliacion-ayuda">
                  Selecciona la institución o instituciones del Sistema Nacional de Salud en las que el paciente se encuentra afiliado. Puedes elegir hasta 9 opciones; no especificado, ninguna y se ignora no se pueden combinar con otras.
                </p>

                <div className="afiliacion-opciones">
                  {listaAfiliacion.map((item) => {
                    const valor = String(item.CATALOG_KEY);
                    const seleccionadas = Array.isArray(paciente.afiliacion)
                      ? paciente.afiliacion.map(String)
                      : [];

                    const valoresExclusivos = ["0", "1", "99"];
                    const hayExclusivoSeleccionado = seleccionadas.some((v) =>
                      valoresExclusivos.includes(v)
                    );

                    const deshabilitado =
                      hayExclusivoSeleccionado &&
                      !seleccionadas.includes(valor);

                    return (
                      <label
                        key={item.CATALOG_KEY}
                        className={`afiliacion-opcion ${
                          seleccionadas.includes(valor) ? "seleccionada" : ""
                        } ${deshabilitado ? "deshabilitada" : ""}`}
                      >
                        <input
                          type="checkbox"
                          checked={seleccionadas.includes(valor)}
                          disabled={deshabilitado}
                          onChange={() => handleAfiliacionChange(valor)}
                        />
                        <span className="afiliacion-check"></span>
                        <span className="afiliacion-texto">
                          {item["DESCRIPCIÓN LARGA"] || item["DESCRIPCIÓN CORTA"]}
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>
            )}
          </div>    
          <select
          name="seAutodenominaAfromexicano"
          value={paciente.seAutodenominaAfromexicano ?? ""}
          onChange={(e) =>
            setPaciente({
              ...paciente,
              seAutodenominaAfromexicano: e.target.value === "" ? null : Number(e.target.value)
            })
          }
        >
          <option value="">¿Se autodenomina afromexicano?</option>
          <option value="0">No</option>
          <option value="1">Sí</option>
          <option value="2">No responde</option>
          <option value="3">No sabe</option>
        </select>

        <select
          name="seConsideraIndigena"
          value={paciente.seConsideraIndigena ?? ""}
          onChange={(e) =>
            setPaciente({
              ...paciente,
              seConsideraIndigena: e.target.value === "" ? null : Number(e.target.value)
            })
          }
        >
          <option value="">¿Se considera indígena?</option>
          <option value="0">No</option>
          <option value="1">Sí</option>
          <option value="2">No responde</option>
          <option value="3">No sabe</option>
        </select>

        <select
          name="migrante"
          value={paciente.migrante ?? ""}
          onChange={(e) =>
            setPaciente({
              ...paciente,
              migrante: e.target.value === "" ? null : Number(e.target.value)
            })
          }
        >
          <option value="">¿Se considera migrante?</option>
          <option value="0">No</option>
          <option value="1">Nacional</option>
          <option value="2">Internacional</option>
          <option value="3">Retornado</option>
        </select>

        {paciente.migrante === 2 && (
          <select
            name="paisProcedencia"
            value={paciente.paisProcedencia ?? ""}
            required
            onChange={(e) =>
              setPaciente({
                ...paciente,
                paisProcedencia: e.target.value ? Number(e.target.value) : null
              })
            }
          >
            <option value="">País de procedencia*</option>

            {listaPaises
              .filter(p => p.CATALOG_KEY !== 142)
              .map((pais) => (
                <option key={pais.CATALOG_KEY} value={pais.CATALOG_KEY}>
                  {pais.DESCRIPCION}
                </option>
              ))
            }
          </select>
        )}

        <select
          name="genero"
          value={paciente.genero ?? ""}
          onChange={(e) =>
            setPaciente({
              ...paciente,
              genero: e.target.value === "" ? null : Number(e.target.value)
            })
          }
        >
          <option value="" disabled>Género*</option>
          <option value="0">No especificado</option>
          <option value="1">Masculino</option>
          <option value="2">Femenino</option>
          <option value="3">Transgénero</option>
          <option value="4">Transexual</option>
          <option value="5">Travesti</option>
          <option value="6">Intersexual</option>
          <option value="88">Otro</option>
        </select>

        </>
        )}

        {/* Residencia NOM-024 */}
        <h3>Residencia</h3>
        <select
          value={paciente.paisResidencia ?? ""}
          onChange={(e) => handlePaisResidencia(e.target.value || null)}
        >
          <option value="" disabled>País de residencia*</option>
          {listaPaises.map((pais) => (
            <option key={pais.CATALOG_KEY} value={pais.CATALOG_KEY}>
              {pais.DESCRIPCION}
            </option>
          ))}
        </select>

        {String(paciente.paisResidencia) === "142" && (
          <select
            value={paciente.entidadResidencia ?? ""}
            onChange={(e) => handleEntidadResidencia(e.target.value ? e.target.value : null)}
          >
            <option value="" disabled>Entidad de residencia*</option>
            {listaEntidades.filter((e) => String(e.CATALOG_KEY) !== "88").map((e) => (
              <option key={e.CATALOG_KEY} value={e.CATALOG_KEY}>
                {e.ENTIDAD_FEDERATIVA}
              </option>
            ))}
          </select>
        )}

        {String(paciente.paisResidencia) === "142" && paciente.entidadResidencia && !esEntidadEspecial(paciente.entidadResidencia) && (
          <select
            value={paciente.municipio ?? ""}
            onChange={(e) => handleMunicipio(e.target.value || null)}
          >
            <option value="" disabled>Municipio de residencia*</option>
           <option value="998">SE IGNORA - 998</option>
           <option value="999">NO ESPECIFICADO - 999</option>
            {listaMunicipios.map((m) => (
              <option key={m.CATALOG_KEY} value={m.CATALOG_KEY}>
                 {m.MUNICIPIO} - {m.CATALOG_KEY}
              </option>
            ))}
          </select>
        )}

        {String(paciente.paisResidencia) === "142" && paciente.municipio && !esMunicipioEspecial(paciente.municipio) && (
          <select
            value={paciente.localidad ?? ""}
            onChange={(e) => setPaciente(prev => ({ ...prev, localidad: e.target.value || null }))}
          >
            <option value="" disabled>Localidad de residencia*</option>
           <option value="9998">SE IGNORA - 9998</option>
           <option value="9999">NO ESPECIFICADO - 9999</option>
            {listaLocalidades.map((l) => (
              <option key={l.CATALOG_KEY} value={l.CATALOG_KEY}>
                {l.LOCALIDAD} - {l.CATALOG_KEY}
              </option>
            ))}
          </select>
        )}
        

        {/* Dirección */}
        <h3>Dirección</h3>
        <input
          type="text"
          name="calle"
          placeholder="Calle y Número"
          value={paciente.direccion.calle}
          onChange={(e) => handleNestedChange(e, "direccion")}
        />
        <input
          type="text"
          name="colonia"
          placeholder="Colonia"
          value={paciente.direccion.colonia}
          onChange={(e) => handleNestedChange(e, "direccion")}
        />
        <input
          type="text"
          name="ciudad"
          placeholder="Ciudad"
          value={paciente.direccion.ciudad}
          onChange={(e) => handleNestedChange(e, "direccion")}
        />
        <input
          type="text"
          name="estado"
          placeholder="Estado"
          value={paciente.direccion.estado}
          onChange={(e) => handleNestedChange(e, "direccion")}
        />
        <input
          type="text"
          name="codigo_postal"
          placeholder="Código Postal"
          value={paciente.direccion.codigo_postal}
          onChange={(e) => handleNestedChange(e, "direccion")}
        />
        {errors.codigo_postal && <p className="error">{errors.codigo_postal}</p>}

        {/* Motivo de Consulta */}
        <h3>Motivo de Consulta</h3>
        <textarea
          name="motivo_consulta"
          placeholder="Describa el motivo de consulta"
          value={paciente.motivo_consulta}
          onChange={handleChange}
        ></textarea>

        {/* Botón de Enviar */}
        {errors.telefono && <p className="error">{errors.telefono}</p>}
        {errors.curp && <p className="error">{errors.curp}</p>}
        {errors.codigo_postal && <p className="error">{errors.codigo_postal}</p>}

        </div>

        {registroExpress && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Registro Express</h3>
              <p>⚠ ¿Estás seguro de que deseas continuar con el registro express? Puedes completar los datos restantes más tarde desde el expediente (Ficha de identificación → Editar).</p>
              {perfil?.nom024 && <p>⚠ Para cumplir normativa, los datos deberán estar completos antes de realizar la primera consulta.</p>}
              <div className="modal-buttons">
                <button type="button" className="button-express" onClick={() => handleRegistroExpress(true)} disabled={guardandoPaciente}>
                  {guardandoPaciente ? "Guardando…" : "Sí, continuar"}
                </button>
                <button type="button" className="button-express" onClick={() => handleRegistroExpress(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        )}

        {!registroExpress && (
        <button type="submit" disabled={guardandoPaciente}>
          {guardandoPaciente ? "Guardando…" : "Registrar Paciente"}
        </button>
      )}
      </form>
      <ConfirmarPalabraInconvenienteCURP
  visible={confirmarPalabraInconveniente}
  onConfirm={() => {
  curpPalabraInconvenienteConfirmadaRef.current = true;
  setCurpPalabraInconvenienteConfirmada(true);
  setConfirmarPalabraInconveniente(false);

  setTimeout(() => {
    document.querySelector("form")?.requestSubmit();
  }, 0);
}}
  onCancel={() => {
  curpPalabraInconvenienteConfirmadaRef.current = false;
  setConfirmarPalabraInconveniente(false);
  setCurpPalabraInconvenienteConfirmada(false);
}}  
/>
    </div>
  );
};

export default AltaPaciente;
